import Axios from 'axios';
import { Config } from '../apiRoutes';

import {
  SEARCH_PRODUCT_REQUESTED,
  SEARCH_PRODUCT_SUCCESS,
  SEARCH_PRODUCT_FAILURE,
  UPDATE_SELECTED_ITEMS,
  UPDATE_SELECTED_PRODUCTS,
  UPDATE_SELECTED_PRODUCT,
  // SEARCH_PRODUCT_SKU_REQUESTED,
  // SEARCH_PRODUCT_SKU_SUCCESS,
  // SEARCH_PRODUCT_SKU_FAILURE,
  DOWNLOAD_PREVIEW_REQUESTED,
  DOWNLOAD_PREVIEW_SUCCESS,
  DOWNLOAD_PREVIEW_FAILURE,
  FIND_BARCODE_IMAGE_REQUESTED,
  FIND_BARCODE_IMAGE_SUCCESS,
  FIND_BARCODE_IMAGE_FAILURE,
  SEARCH_PRODUCT_BARCODE_VALUE_REQUESTED,
  SEARCH_PRODUCT_BARCODE_VALUE_SUCCESS,
  SEARCH_PRODUCT_BARCODE_VALUE_FAILURE,
} from '../types';

export const searchProductsRequested = () => {
  return {
    type: SEARCH_PRODUCT_REQUESTED
  }
};

export const searchProductsSuccess = (products) => {
  return {
    type: SEARCH_PRODUCT_SUCCESS,
    payload: products
  }
};

export const searchProductsFailure = (error) => {
  return {
    type: SEARCH_PRODUCT_FAILURE,
    status: error.response?.status,
    message: error.message,
  }
};

export const setSelectedItems = (items) => {
  return {
    type: UPDATE_SELECTED_ITEMS,
    payload: items
  }
}

export const setSelectedProducts = (products) => {
  return {
    type: UPDATE_SELECTED_PRODUCTS,
    payload: products
  }
}

export const updateSelectedProduct = (product) => {
  return {
    type: UPDATE_SELECTED_PRODUCT,
    payload: product
  }
}

// export const searchProductSkuRequested = () => {
//   return {
//     type: SEARCH_PRODUCT_SKU_REQUESTED
//   }
// };

// export const searchProductSkuSuccess = (products) => {
//   return {
//     type: SEARCH_PRODUCT_SKU_SUCCESS,
//     payload: products
//   }
// };

// export const searchProductSkuFailure = () => {
//   return {
//     type: SEARCH_PRODUCT_SKU_FAILURE
//   }
// };

export const downloadPreviewRequested = () => {
  return {
    type: DOWNLOAD_PREVIEW_REQUESTED
  }
};

export const downloadPreviewSuccess = (previewUrl) => {
  return {
    type: DOWNLOAD_PREVIEW_SUCCESS,
    payload: previewUrl
  }
};

export const downloadPreviewFailure = (error) => {
  return {
    type: DOWNLOAD_PREVIEW_FAILURE,
    status: error.response?.status,
    message: error.message,
  }
};

export const findBarcodeImageRequested = (fileRequested) => {
  return {
    type: FIND_BARCODE_IMAGE_REQUESTED,
    payload: fileRequested
  }
}

export const findBarcodeImageSuccess = (result) => {
  return {
    type: FIND_BARCODE_IMAGE_SUCCESS,
    payload: result
  }
}

export const findBarcodeImageFailure = (error) => {
  return {
    type: FIND_BARCODE_IMAGE_FAILURE,
    status: error.response?.status,
    message: error.message,
  }
}


export const searchProductBarcodeValueRequested = () => {
  return {
    type: SEARCH_PRODUCT_BARCODE_VALUE_REQUESTED
  }
};

export const searchProductBarcodeValueSuccess = (products) => {
  return {
    type: SEARCH_PRODUCT_BARCODE_VALUE_SUCCESS,
    payload: products
  }
};

export const searchProductBarcodeValueFailure = (error) => {
  return {
    type: SEARCH_PRODUCT_BARCODE_VALUE_FAILURE,
    status: error.response?.status,
    message: error.message,
  }
};


export const searchProducts = (shopUrl, payload, searchTerm, inStockFilter, productTypeFilter, vendorFilter, direction, endCursor, startCursor) => {
  return (dispatch) => {
    dispatch(searchProductsRequested());

    let endPoint = Config.baseUrl + Config.productSearch;
    let headers = Object.assign(Config.headers);

    headers.payload = payload;
    headers.shop = shopUrl;

    let body = {
      'term': searchTerm,
      'in_stock_filter': inStockFilter,
      'product_type': productTypeFilter,
      'vendor_filter': vendorFilter,
      'direction': direction,
      'endCursor': endCursor,
      'startCursor': startCursor
    }

    return Axios.post(endPoint, body, { headers: headers })
      .then((response) => {
        dispatch(searchProductsSuccess(response.data));
      })
      .catch((error) => {
        dispatch(searchProductsFailure(error));
      });
  }
}

export const updateSelectedItems = (items, relatedProduct) => {
  return (dispatch) => {
    dispatch(setSelectedItems(items));
    if(relatedProduct) { dispatch(updateRelatedProduct(relatedProduct)); }
  }
}

export const updateSelectedProducts = (products) => {
  return (dispatch) => {
    dispatch(setSelectedProducts(products));
  }
}

export const updateRelatedProduct = (product) => {
  return (dispatch) => {
    dispatch(updateSelectedProduct(product));
  }
}

// export const searchProductSku = (shopUrl, payload, barcode) => {
//   return (dispatch) => {
//     dispatch(searchProductSkuRequested());

//     let endPoint = Config.baseUrl + Config.barcode + Config.search;
//     let headers = Object.assign(Config.headers);
//     headers.shop = shopUrl;
//     headers.payload = payload;

//     return Axios.post(endPoint, { 'barcode': barcode } , { headers: headers })
//       .then((response) => {
//         dispatch(searchProductSkuSuccess(response.data));
//       });
//   }
// }

export const downloadBarcodePreview = (shopUrl, payload) => {
  return (dispatch) => {
    dispatch(downloadPreviewRequested());

    let endPoint = Config.baseUrl + Config.preview + Config.download;
    let headers = Object.assign(Config.headers);
    headers.shop = shopUrl;
    headers.payload = payload;

    return Axios.get(endPoint, { headers: headers })
      .then((response) => {
        dispatch(downloadPreviewSuccess(response.data));
      })
      .catch((error) => {
        dispatch(downloadPreviewFailure(error));
      });
  }
}

export const findBarcodeImage = (shopUrl, payload, itemId, symbol) => {
  return (dispatch) => {
    dispatch(findBarcodeImageRequested(symbol));

    let endPoint = Config.baseUrl + Config.barcode + Config.imageCheck + '?symbol=' + symbol + '&itemId=' + itemId;
    let headers = Object.assign(Config.headers);
    headers.shop = shopUrl;
    headers.payload = payload;

    return Axios.get(endPoint, { headers: headers })
      .then((response) => {
        dispatch(findBarcodeImageSuccess(response.data));
      })
      .catch((error) => {
        dispatch(findBarcodeImageFailure(error));
      });
  }
}

export const searchProductBarcodeValue = (shopUrl, payload, barcode) => {
  return (dispatch) => {
    dispatch(searchProductBarcodeValueRequested());

    let endPoint = Config.baseUrl + Config.barcode + Config.search;
    let headers = Object.assign(Config.headers);
    headers.payload = payload;
    headers.shop = shopUrl;

    return Axios.post(endPoint, { 'barcode': barcode } , { headers: headers })
      .then((response) => {
        dispatch(searchProductBarcodeValueSuccess(response.data));
      })
      .catch((error) => {
        dispatch(searchProductBarcodeValueFailure(error));
      });
  }
}
